<template>
<div style="font-family: -apple-system-font,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
  <div class="carousel">
    <img src="../assets/images/developerCommunity/dev_banner.jpg" alt="">
  </div>
  <div class="dev_main">
    <div class="dev_item evenflow_scale" @click="showDetail('DeveloperDzxDetail')">
      <div class="item_left">
        <div class="item_title">
          <img src="../assets/images/developerCommunity/dev_red_line.png" alt=""> <span>MQTT物联网通讯协议介绍</span>
        </div>
        <div class="item_content">
          MQTT（Message Queuing Telemetry Transport，消息队列遥测传输协议），是一种基于发布/订阅（publish/subscribe）模式的“轻量级”通讯协议...
        </div>
        <div class="item_time">
          <span><img src="../assets/images/developerCommunity/dev_time.png" alt="">2020/06/12</span>
          <span><img src="../assets/images/developerCommunity/dev_people.png" alt="">Eiiplat 平台</span>
        </div>
      </div>
      <div class="item_right">
        <img src="../assets/images/developerCommunity/dev_p4.png">
      </div>
    </div>
    <div class="dev_item evenflow_scale" @click="showDetail('DeveloperDsjDetail')">
      <div class="item_left">
        <div class="item_title">
          <img src="../assets/images/developerCommunity/dev_red_line.png" alt=""> <span>大数据分析平台的难点及突破方法</span>
        </div>
        <div class="item_content">
          近年来，随着互联网信息技术的不断发展，大量传感器，终端接入互联网，上传了海量的数据。所以使用Hadoop之类的大数据平台存储大量数据...
        </div>
        <div class="item_time">
          <span><img src="../assets/images/developerCommunity/dev_time.png" alt="">2020/06/12</span>
          <span><img src="../assets/images/developerCommunity/dev_people.png" alt="">Eiiplat 平台</span>
        </div>
      </div>
      <div class="item_right">
        <img src="../assets/images/developerCommunity/dev_p2.png">
      </div>
    </div>
    <div class="dev_item evenflow_scale" @click="showDetail('DeveloperJqxxDetail')">
      <div class="item_left">
        <div class="item_title">
          <img src="../assets/images/developerCommunity/dev_red_line.png" alt=""> <span>机器学习简介</span>
        </div>
        <div class="item_content">
          机器学习研究的是计算机怎样模拟人类的学习行为，以获取新的知识或技能，并重新组织已的知识结构使之不断改善自身。简而言之，就是计算机从...
        </div>
        <div class="item_time">
          <span><img src="../assets/images/developerCommunity/dev_time.png" alt="">2020/06/12</span>
          <span><img src="../assets/images/developerCommunity/dev_people.png" alt="">Eiiplat 平台</span>
        </div>
      </div>
      <div class="item_right">
        <img src="../assets/images/developerCommunity/dev_p3.png">
      </div>
    </div>
    <div class="dev_item evenflow_scale" @click="showDetail('DeveloperGyhlwDetail')">
      <div class="item_left">
        <div class="item_title">
          <img src="../assets/images/developerCommunity/dev_red_line.png" alt=""> <span>工业互联网加速落地深耕</span>
        </div>
        <div class="item_content">
          工业互联网领域“新政”和相关研究成果频频出炉：工信部近日发布《关于推动工业互联网加快发展的通知》（以下简称《通知》，要求推动工业展新...
        </div>
        <div class="item_time">
          <span><img src="../assets/images/developerCommunity/dev_time.png" alt="">2020/06/12</span>
          <span><img src="../assets/images/developerCommunity/dev_people.png" alt="">Eiiplat 平台</span>
        </div>
      </div>
      <div class="item_right">
        <img src="../assets/images/developerCommunity/dev_p5.png">
      </div>
    </div>
    <div class="dev_item evenflow_scale" @click="showDetail('DeveloperDetail')">
      <div class="item_left">
        <div class="item_title ">
          <img src="../assets/images/developerCommunity/dev_red_line.png" alt=""> <span>区块链开源技术有哪些</span>
        </div>
        <div class="item_content">
          第一类：Bletchley —— 微软开源区块链平台项目,微软称已经了解区块链的基本原理，以及其特点，将把区块链整合到企业级项目中...
        </div>
        <div class="item_time evenflow_scale">
          <span><img src="../assets/images/developerCommunity/dev_time.png" alt="">2020/06/12</span>
          <span><img src="../assets/images/developerCommunity/dev_people.png" alt="">Eiiplat 平台</span>
        </div>
      </div>
      <div class="item_right ">
        <img src="../assets/images/developerCommunity/dev_p1.png">
      </div>
    </div>

  </div>
  <div class="page">
    <div class="page_chage page_pre">
      上一页
    </div>
    <div class="page_info">
      共<span class="current_page">1</span>/<span class="total_page">8</span>页
    </div>
    <div class="page_chage page_next">
      下一页
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'DeveloperCommunity',
  data() {
    return {

    }
  },
  methods: {
    showDetail(page) {
      this.$router.push({
        path: '/solition_lower/' + page,
        name: page, //必须带name属性，要不然参数传递不成功。
        params: {}
      });
    }
  }
}
</script>

<style lang="scss">
.carousel {
  img {
    width: 100%;
  }
}

.dev_main {
  padding: 0 2.4rem;

  .dev_item {
    overflow: hidden;
    cursor: pointer;
    margin-top: 0.6rem;
    height: 4rem;
    box-shadow: 0rem 0.04rem 0.3rem 0rem rgba(204, 204, 204, 0.7);
    background-color: rgb(255, 255, 255);
    display: flex;
    justify-content: space-between;

    .item_left {
      margin: 0.8rem 1.2rem;
      margin-right: 0.6rem;

      .item_title {
        display: flex;
        align-items: center;
        overflow: hidden;


        img {
          width: 0.04rem;
          height: 0.3rem;
          margin-right: 0.2rem;
        }

        span {
          font-size: 0.32rem;
        }
      }

      .item_content {
        margin: 0.4rem 0;
        font-size: 0.18rem;
        overflow: hidden;
      }

      .item_time {
        display: flex;

        span {
          font-size: 0.18rem;
          color: #999;
          margin-right: 0.35rem;
          display: flex;
          align-items: center;
          overflow: hidden;
        }

        img {
          width: 0.2rem;
          height: 0.2rem;
          margin-right: 0.1rem;
        }
      }
    }

    .item_right {
      margin: 0.8rem 1.2rem;
      margin-left: 0;

      img {
        width: 3.2rem;
        height: 2.4rem;
      }
    }
  }
}

.page {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.6rem;
  margin-bottom: 1.2rem;

  .page_chage {
    padding: 0.15rem 0.4rem;
    border: 0.01rem #999999 solid;
    cursor: pointer;
  }

  .page_pre {
    color: #999999;
  }

  .page_info {
    margin: 0 0.4rem;

    .current_page {
      color: red;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DeveloperCommunity.vue